import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { History } from "lucide-react";

const LABELS = {
  set_role: "Changed role", create_access_code: "Created access code", disable_access_code: "Disabled access code",
  enable_access_code: "Enabled access code", invite_with_access: "Invited with free access",
};

export default function AdminActivity() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/activity").then((r) => setRows(r.data)).catch((e) => { logError("activity", e); setRows([]); }); }, []);
  return (
    <section className="bg-card border border-border rounded-2xl p-5" data-testid="admin-activity">
      <p className="font-display font-semibold flex items-center gap-2 mb-1"><History className="w-4 h-4 text-accent" /> Admin activity</p>
      <p className="text-xs text-muted-foreground mb-4">Who granted admin rights, created or disabled access codes, and sent invites — newest first.</p>
      {rows === null ? <p className="text-sm text-muted-foreground">Loading…</p> : rows.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="admin-activity-empty">Nothing logged yet.</p>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead className="bg-muted/50 text-left text-xs uppercase tracking-wide text-muted-foreground">
              <tr><th className="px-4 py-2">When</th><th className="px-4 py-2">Who</th><th className="px-4 py-2">Action</th><th className="px-4 py-2">Target</th><th className="px-4 py-2">Details</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-border" data-testid={`activity-row-${r.id}`}>
                  <td className="px-4 py-2 whitespace-nowrap text-muted-foreground">{new Date(r.at).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
                  <td className="px-4 py-2">{r.actor}</td>
                  <td className="px-4 py-2 font-medium">{LABELS[r.action] || r.action}</td>
                  <td className="px-4 py-2 font-mono text-xs">{r.target}</td>
                  <td className="px-4 py-2 text-muted-foreground">{r.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
